<template>
  <md-toolbar 
    id="toolbar" 
    md-elevation="0" 
    class="md-white"
  >
    <div class="md-toolbar-row md-collapse-lateral">
      <div class="md-toolbar-section-start">
        <router-link :to="'/'">
          <img src="@/assets/images/LR_Logo.png" class="navbar-image"/>
        </router-link>
        <div class="navTitle">
          <h3 v-if="!toggledClass" class="md-title">Balkon &amp; Zaun-Profi<br>Leibhammer + Rietz GmbH</h3>
        </div>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-simple md-toolbar-toggle"
          :class="{ toggled: toggledClass }"
          @click="toggleNavbarMobile()"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>
        <div class="md-collapse">
          <div class="md-collapse-wrapper">
            <mobile-menu nav-mobile-section-start="false">
    <!-- Here you can add your items from the section-start of your toolbar -->
            </mobile-menu>
            <md-list>
              <md-list-item href="#/" @click="toggleNavbarMobile()">
                <p>Startseite</p>
              </md-list-item>
              <md-list-item href="#/produkte" @click="toggleNavbarMobile()">
                <p>Produkte</p>
              </md-list-item>
              <md-list-item md-button-clean dropdown href="#/vertriebspartner" @click="toggleNavbarMobile()">
                <p>Vertriebspartner</p>
              </md-list-item>
 <md-list-item md-button-clean dropdown href="#/veranstaltungen" @click="toggleNavbarMobile()">
                <p>Veranstaltungen</p>
              </md-list-item>
              <md-list-item v-if="currentRouteName() === 'datenschutz' || 'impressum'" href="#/#about" @click="toggleNavbarMobile()">
                <p>Über uns</p>
              </md-list-item>  
              <md-list-item v-else href="javascript:void(0)" @click="scrollToElement('about'), toggleNavbarMobile()">
                <p>Über uns</p>
              </md-list-item>
              <md-list-item v-if="currentRouteName() === 'datenschutz' || 'impressum'" href="#/#contact" @click="toggleNavbarMobile()">
                <p>Kontakt</p>
              </md-list-item>
              <md-list-item v-else href="javascript:void(0)" @click="scrollToElement('contact'), toggleNavbarMobile()">
                <p>Kontakt</p>
              </md-list-item>
            </md-list>
          </div>  
        </div>  
      </div>
    </div>
  </md-toolbar>
</template>

<script>
let resizeTimeout;
function resizeThrottler(actualResizeHandler) {
  // ignore resize events as long as an actualResizeHandler execution is in the queue
  if (!resizeTimeout) {
    resizeTimeout = setTimeout(() => {
      resizeTimeout = null;
      actualResizeHandler();

      // The actualResizeHandler will execute at a rate of 15fps
    }, 66);
  }
}

import MobileMenu from "@/layout/MobileMenu";

export default {
  components: {
    MobileMenu
  },
  props: {
    type: {
      type: String,
      default: "white",
      validator(value) {
        return [
          "white",
          "default",
          "primary",
          "danger",
          "success",
          "warning",
          "info"
        ].includes(value);
      }
    },
    colorOnScroll: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      toggledClass: false
    };
  },
  methods: {
    currentRouteName() {
        return this.$route.name;
    },
    bodyClick() {
      let bodyClick = document.getElementById("bodyClick");

      if (bodyClick === null) {
        let body = document.querySelector("body");
        let elem = document.createElement("div");
        elem.setAttribute("id", "bodyClick");
        body.appendChild(elem);

        let bodyClick = document.getElementById("bodyClick");
        bodyClick.addEventListener("click", this.toggleNavbarMobile);
      } else {
        bodyClick.remove();
      }
    },
    toggleNavbarMobile() {

      if(window.matchMedia("(max-width: 1024px)").matches) {
        this.Navbar.showNavbar = !this.Navbar.showNavbar;
        this.toggledClass = !this.toggledClass;
        this.bodyClick();
      }
    },
    scrollListener() {
      resizeThrottler(this.handleScroll);
    },
    scrollToElement(element) {
      let element_id = document.getElementById(element);
      if (element_id) {
        element_id.scrollIntoView({ block: "start", behavior: "smooth" });
      }
      element_id = null;
    }
  },
  mounted() {
    document.addEventListener("scroll", this.scrollListener);
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.scrollListener);
  }
};
</script>

<style lang="css"></style>
